(() => {
  const carouselInit = () => {
    Alpine.data("gliderCarousel", () => ({
      init() {
        const showArrows = this.$el.dataset.showArrows === "true";
        const showDots = this.$el.dataset.showDots === "true";
        const gliderOpts = {
          slidesToShow: +this.$el.dataset.mobileSlideCount,
          slidesToScroll: +this.$el.dataset.mobileScrollCount,
          draggable: true,
          scrollLock: true,
          skipTrack: true,
          duration: 3,
          exactWidth: false,
          arrows: {
            prev: this.$refs.prevButton,
            next: this.$refs.nextButton,
          },
          dots: this.$refs.dots,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: +this.$el.dataset.tabletSlideCount,
                slidesToScroll: +this.$el.dataset.tabletScrollCount,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: +this.$el.dataset.desktopSlideCount,
                slidesToScroll: +this.$el.dataset.desktopScrollCount,
              },
            },
          ],
        };

        if (window.Glider) {
          const carousel = new Glider(this.$el, gliderOpts);
        } else {
          document.addEventListener("glider-loaded", () => {
            const carousel = new Glider(this.$el, gliderOpts);
          });
        }
      },
    }));
  };
  if (window.Alpine) {
    carouselInit();
  } else {
    document.addEventListener("alpine:init", carouselInit, {
      once: true,
    });
  }
})();
